import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconRepairValidation from '@/icons/RepairValidation.svg';
import { REPAIR_ISSUES } from '@/routes/Requests/Request/Article/components/ArticleActions/ReportRepairIssueDialog';

export const ArticleRepairIssueReportedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_repair_issue_reported'>;
  displayArticleName: boolean;
}) => {
  const { i18n, t } = useLingui();

  const workshopName = activity.workshop.name;
  const creatorName = activity.creator?.name;
  const issueData = REPAIR_ISSUES.find(({ id }) => id === activity.data.issue);
  const issueFormated = issueData ? i18n._(issueData.label) : null;
  const commentFormated = activity.data.comment
    ? t({ id: '_general.colon', message: ':' }) + ' ' + activity.data.comment
    : '';

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="danger"
      icon={<IconRepairValidation />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfWorkshop ? (
            <Trans id="activities.article_repair_issue_reported.message.on-behalf">
              <strong>{creatorName}</strong> reported a repair issue on behalf of{' '}
              <strong>{workshopName}</strong> for the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />
            </Trans>
          ) : (
            <Trans id="activities.article_repair_issue_reported.message">
              <strong>{creatorName}</strong> reported a repair issue on the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      <BaseActivityDetailedContent>
        <>
          {issueFormated}
          {commentFormated}
        </>
      </BaseActivityDetailedContent>
    </BaseActivity>
  );
};
